<template>
  <div class="css-jl1qws new-order-dialog d-dialog" @click.stop="closeAll">
    <div class="sc-bdVaJa keQvRI"></div>
    <slide-x-left-transition>
      <div class="css-wgk558" v-show="isShowThis">
        <div class="css-7bwbxg">
          <div class="d-content" v-loading="loading.order || loading.orderUpdate" :class="{'d-content-print':isPrintModel}">
            <header class="c">
              <h1>计算器</h1> <!-- 添加标题 -->
              <a v-show="!isPrintModel" href="javascript:void(0);" class="c a-btn" title="关闭" @click.stop="closeDialog">
                <i class="el-icon-close" style="font-size: 22px; padding: 4px 6px;"></i>
              </a>
            </header>
            <slide-x-left-transition>
              <div class="main main-body">
                <div>
                  <div class="l">
                    <div>
                      <h6>长 mm</h6>
                      <el-input class="search-input" @change="submit()" placeholder="长" v-model="长" clearable></el-input>
                    </div>
                    <div>
                      <h6>宽 mm</h6>
                      <el-input class="search-input" @change="submit()" placeholder="宽" v-model="宽" clearable></el-input>
                    </div>
                    <div>
                      <h6>厚 mm</h6>
                      <el-input class="search-input" @change="submit()" placeholder="厚" v-model="厚" clearable></el-input>
                    </div>
                    <div>
                      <h6>密度</h6>
                      <el-input class="search-input" @change="submit()" placeholder="密度" v-model="密度" clearable></el-input>
                    </div>
                    <div class="mat-group">
                      <el-radio-group v-model="selectedMaterial" size="mini" @change="setMaterial">
                        <el-radio-button label="不锈钢"></el-radio-button>
                        <el-radio-button label="铁板"></el-radio-button>
                        <el-radio-button label="锰板"></el-radio-button>
                        <el-radio-button label="镀锌"></el-radio-button>
                      </el-radio-group>
                    </div>
                    <div>
                      <h6>结果</h6>
                      <div class="result-container">
                        <div class="result-item">
                          <i class="el-icon-data-analysis result-icon"></i>
                          <span class="result">平方 {{ 平方 | toFixed4 }}㎡</span>
                        </div>
                        <div class="result-item">
                          <i class="el-icon-data-analysis result-icon"></i>
                          <span class="result">公式 = {{ 长 / 1000 }} * {{ 宽/1000 }} * {{ 厚/100 }} * {{ 密度 }} = {{ 结果 | toFixed4 }}</span>
                        </div>
                        <div class="result-item">
                          <i class="el-icon-data-analysis result-icon"></i>
                          <span class="result">重量 {{ 结果 * 1000|toFixed4 }} kg ({{结果 * 2 * 1000|toFixed4}}斤)</span>
                        </div>
                         <!-- 新增总价输入框 -->
                         <!-- 在总价输入框前添加隐藏的假密码输入框 -->
                        <div style="position: absolute; left: -9999px; top: -9999px;">
                          <input type="password" tabindex="-1" />
                        </div>
                        <div class="result-item">
                          <i class="el-icon-data-analysis result-icon"></i>
                          <span class="result">总价</span>
                          <el-input
                              autocomplete="new-password"
                              :name="'tp-'+uniqueId"
                              :id="'tp-'+uniqueId"
                              class="price-input" @input="calculatePricePerKg" placeholder="输入总价" v-model="总价" clearable></el-input>
                        </div>

                        <!-- 显示每公斤价格 -->
                        <div class="result-item" v-if="每公斤价格 > 0">
                          <i class="el-icon-data-analysis result-icon"></i>
                          <span class="result">单价: {{ 每公斤价格 | toFixed2 }} 元/kg</span>
                        </div>
                        <div class="result-item" style="flex-wrap: wrap ;">
                          <div style="width: 100%;">
                            <i class="el-icon-data-analysis result-icon"></i>
                            <span class="result" style="margin-right: 15px">{{ 价格预设1 }}元</span>
                          </div>
                          <div style="width: 100%;">
                            <i class="el-icon-data-analysis result-icon"></i>
                            <span class="result" style="margin-right: 15px">{{ 价格预设2 }}元</span>
                          </div>
                          <div style="width: 100%;">
                            <i class="el-icon-data-analysis result-icon"></i>
                            <span class="result" style="margin-right: 15px">{{ 价格预设3 }}元</span>
                          </div>
                          <div style="width: 100%;">
                            <i class="el-icon-data-analysis result-icon"></i>
                            <span class="result" style="margin-right: 15px">{{ 价格预设4 }}元</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="r">
                    <div class="container">
                      <div class="canvas-container">
                        <canvas id="drawingCanvas" width="700" height="500"></canvas>
                        <div id="errorMessage" class="error-message"></div>
                        <div id="infoMessage" class="info-message"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ==================== 价格预测 ==================== -->
                <div class="buy-predict-wrap">
                  <div class="bp-head">
                    <h1>价格预测</h1>
                    <span class="bp-tag">价格取自江山对账单 {{ buyModel.source.records }} 条有效成交记录（{{ buyModel.source.range }}）· 同尺寸只取最新一条 · ≤{{ buyModel.thinThick }}mm 按平方计价（吨价并列保留）· 不做理论外推 · 该厚度无成交时退回历史成交记录搬同材质样本最多档做通用预测（标注搬自哪一档）</span>
                  </div>

                  <div class="bp-main">
                    <!-- 输入 -->
                    <div class="bp-inputs">
                      <div class="bp-field">
                        <label>厚度 mm</label>
                        <el-input class="search-input" @change="submit()" placeholder="厚" v-model="厚" size="small" clearable></el-input>
                      </div>
                      <div class="bp-field">
                        <label>单件面积</label>
                        <span class="bp-val">{{ 平方 | toFixed4 }} <em>㎡</em></span>
                      </div>
                      <div class="bp-field">
                        <label>面积档</label>
                        <span class="bp-val">{{ buyAreaBand.label }}</span>
                      </div>
                      <div class="bp-field">
                        <label>计价材质</label>
                        <span class="bp-val">
                          {{ selectedMaterial }}
                          <em class="bp-coef" v-if="buyHasHist">取该厚度成交价</em>
                          <em class="bp-generic" v-else-if="buyIsGeneric">通用预测 · 搬自 {{ buyPredict.ref.material }} {{ buyPredict.ref.thickness }}mm</em>
                          <em class="bp-nomodel" v-else-if="(厚 - 0) > 0">无成交记录</em>
                          <em class="bp-nomodel" v-else>待输入厚度</em>
                        </span>
                        <span class="bp-sync">跟随上方材质</span>
                      </div>
                      <div class="bp-field bp-warnbox" v-if="buyMaterialWarn">
                        <i class="el-icon-warning-outline"></i>
                        <span>{{ buyMaterialWarn }}</span>
                      </div>
                    </div>

                    <!-- 输出：≤3mm 薄板且命中精确层时，主口径为每平方价（元/㎡），吨价并列保留 -->
                    <div class="bp-outputs" v-if="buyPredictOk">
                      <div class="bp-out" :class="{ 'is-main': buyPerSqmIsMain }">
                        <span class="bp-out-label">
                          {{ buyIsGeneric ? '参考每平方价（按' + buyPredict.ref.thickness + 'mm换算）' : '预测每平方价' }}
                          <span class="bp-out-tag" v-if="buyPerSqmIsMain">主口径 · 薄板按平方</span>
                        </span>
                        <span class="bp-out-val">{{ fmt(buyPerSqm, 2) }}<em>元/㎡</em></span>
                      </div>
                      <div class="bp-out" :class="{ 'is-main': buyPerTonIsMain }">
                        <span class="bp-out-label">预测每吨价<span class="bp-out-tag" v-if="buyPerTonIsMain">主口径</span>
                          <span class="bp-out-tag is-generic" v-if="buyIsGeneric">通用预测 · 搬自 {{ buyPredict.ref.material }} {{ buyPredict.ref.thickness }}mm（{{ buyPredict.ref.count }}条）</span>
                        </span>
                        <span class="bp-out-val">{{ fmt(buyPerTon, 0) }}<em>元/t</em></span>
                      </div>
                    </div>
                    <div class="bp-outputs bp-na-box" v-else>
                      <div class="bp-na">
                        <i class="el-icon-warning-outline"></i>
                        <div v-if="(厚 - 0) > 0">
                          <b>{{ selectedMaterial }} 无成交记录，无法预测</b>
                          <p v-if="buyThicknessList.length">{{ selectedMaterial }} 现有成交厚度：{{ buyThicknessList.join(' / ') }} mm。</p>
                          <p v-else>{{ buyModel.matNote[selectedMaterial] }}</p>
                          <p>通用预测只搬「同材质里成交记录最多的厚度档」，该材质一条成交都没有，无从搬起。可从上方「可预测组合总览」点选有数据的厚度，或参考市场行情人工报价。</p>
                        </div>
                        <div v-else>
                          <b>请输入厚度后查看预测</b>
                          <p>预测只使用「同材质 + 同厚度」的历史成交记录；该组合没有成交时，退回历史成交记录搬同材质样本最多档做通用预测。</p>
                          <p v-if="buyThicknessList.length">{{ selectedMaterial }} 现有成交厚度：{{ buyThicknessList.join(' / ') }} mm</p>
                          <p v-else>{{ buyModel.matNote[selectedMaterial] }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bp-formula">
                    <span class="bp-formula-label">计算过程</span>
                    <code>{{ buyFormulaText }}</code>
                  </div>

                  <!-- 可预测组合总览（快速查看：哪些材质+厚度有成交数据可依） -->
                  <div class="bp-src-title">
                    可预测组合总览 · 快速查看
                    <span>共 {{ buyCoverageCombos }} 个「材质 + 厚度」组合有历史成交 —— <b class="bp-cov-hint">这些组合给出精确预测</b>（同材质同厚度成交加权）；其他厚度会<b class="bp-cov-hint">退回历史成交记录搬同材质样本最多档</b>做通用预测 · <b class="bp-cov-hint">点厚度可直接填入预测</b>；颜色＝最近成交距今时间</span>
                  </div>

                  <div class="bp-card bp-card-full bp-cov">
                    <div class="bp-cov-row" v-for="m in buyCoverage" :key="m.mat">
                      <span class="bp-cov-mat" :class="{ 'is-on': m.mat === selectedMaterial }">{{ m.mat }}</span>
                      <div class="bp-cov-chips" v-if="m.items.length">
                        <button type="button" v-for="t in m.items" :key="m.mat + t.thick"
                          class="bp-cov-chip"
                          :class="{
                            'is-on': m.mat === selectedMaterial && Math.abs((厚 - 0) - t.thick) < 0.01,
                            'is-old': t.daysAgo > 45 && t.daysAgo <= 90,
                            'is-stale': t.daysAgo > 90
                          }"
                          :title="t.count + ' 条成交 · 最新 ' + t.latest + '（' + t.daysAgo + ' 天前）· 吨价 ' + t.pmin + ' ~ ' + t.pmax + ' 元/t（中位 ' + t.pmed + '）'"
                          @click="pickCoverage(m.mat, t.thick)">
                          <b>{{ t.thick }}</b><em>mm</em><i>{{ t.count }} 条</i>
                        </button>
                      </div>
                      <span class="bp-cov-none" v-else>对账单中无成交记录，无法预测</span>
                      <em class="bp-cov-sum" v-if="m.items.length">{{ m.count }} 条成交</em>
                    </div>
                    <p class="bp-note">
                      <b class="bp-stale-word">精确预测只认「同材质 + 同厚度」，不做插值、不做理论外推。</b>
                      上表没有的厚度不再直接判「无法预测」，而是<b class="bp-generic-word">退回历史成交记录，搬同材质里成交记录最多的那个厚度档</b>做通用预测（面板会标注搬自哪一档，只作量级参考）；<b>连该材质一条成交都没有的（不锈钢），才真正无法预测</b>，需外部报价。
                      蓝框 = 最近成交 45 天内，数据新鲜；<b class="bp-old-word">橙框</b> = 距今 45~90 天，参考价值下降；<b class="bp-stale-word">红框</b> = 距今超过 90 天，只能作为下限参考；药丸内数字 = 该厚度的成交条数，<b>只有 1 条时预测值即该条实价</b>。
                      鼠标悬停可看该厚度档的成交条数与吨价区间。
                    </p>
                  </div>

                  <!-- 历史成交记录（预测依据；填了厚度＝预测同源，没填厚度＝列出全部记录） -->
                  <div class="bp-src-title">
                    历史成交记录 · 预测依据
                    <span v-if="buyHistoryAll">
                      <b class="bp-all-word">未筛选厚度</b> —— 不按厚度过滤，把{{ buyHistoryCrossMat ? '全部材质' : selectedMaterial }}的 {{ buyHistoryView.poolCount }} 条历史成交按<b>成交日期倒序</b>全部列出（{{ buyHistoryView.oldestDate }} ~ {{ buyHistoryView.latestDate }}）· 填入厚度后自动切换为「同材质 + 同厚度」的加权口径
                    </span>
                    <span v-else-if="buyIsGeneric">
                      通用预测参考档：{{ buyPredict.ref.material }} {{ buyPredict.ref.thickness }} mm 共 {{ buyPredict.poolCount }} 条 —— 因 {{ selectedMaterial }} 无 {{ 厚 }} mm 成交，退回历史成交记录搬该档（同材质内成交最多档）加权价，全部列出（按权重降序）· 日期越近权重越高（最新 {{ buyPredict.latestDate }} ×{{ buyModel.timeBoost }}）
                    </span>
                    <span v-else>
                      {{ selectedMaterial }} {{ 厚 || '—' }} mm 共 {{ buyPredict.poolCount }} 条 · 全部为同材质同厚度成交，全部列出（按权重降序）· 日期越近权重越高（最新 {{ buyPredict.latestDate }} ×{{ buyModel.timeBoost }}）
                    </span>
                  </div>

                  <div class="bp-card bp-card-full">
                    <div class="bp-range" v-if="buyHistoryRange">
                      <div class="bp-range-row">
                        <span>{{ buyHistoryRange.scoped ? '同档区间' : '同厚区间' }}</span>
                        <b>{{ buyHistoryRange.min }} ~ {{ buyHistoryRange.max }} 元/t（{{ buyHistoryRange.bandLabel }} · {{ buyHistoryRange.count }} 条）</b>
                        <em>预测 {{ fmt(buyPerTon, 0) }} 元/t · {{ buyRangePosition }}</em>
                      </div>
                      <div class="bp-range-row">
                        <span>最低价</span>
                        <b class="down">{{ buyHistoryRange.minItem[0] }} {{ buyHistoryRange.minItem[2] }} = {{ buyHistoryRange.minItem[7] }} 元/t</b>
                      </div>
                      <div class="bp-range-row">
                        <span>最高价</span>
                        <b class="up">{{ buyHistoryRange.maxItem[0] }} {{ buyHistoryRange.maxItem[2] }} = {{ buyHistoryRange.maxItem[7] }} 元/t</b>
                      </div>
                    </div>
                    <div class="bp-table-wrap">
                      <table class="bp-table">
                        <thead>
                          <tr>
                            <th>日期</th>
                            <th>距最新</th>
                            <th v-if="buyHistoryAll">材质</th>
                            <th>规格</th>
                            <th v-if="buyHistoryAll">厚 mm</th>
                            <th>单件面积 ㎡</th>
                            <th>每㎡价</th>
                            <th>每吨价</th>
                            <th v-if="!buyHistoryAll">时间权重</th>
                            <th v-if="!buyHistoryAll">权重占比</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="h in buyHistoryRows" :key="h.date + h.spec + h.thick + h.mat">
                            <td>{{ h.date }}</td>
                            <td>{{ h.daysAgo }} 天前</td>
                            <td v-if="buyHistoryAll">{{ h.mat }}</td>
                            <td>{{ h.spec }}</td>
                            <td v-if="buyHistoryAll">{{ h.thick }}</td>
                            <td>{{ fmt(h.area, 3) }}</td>
                            <td>{{ fmt(h.perSqm, 2) }}</td>
                            <td class="bp-hl">{{ h.perTon }} 元/t</td>
                            <td class="bp-time-cell" v-if="!buyHistoryAll">×{{ fmt(h.timeFactor, h.timeFactor >= 10 ? 0 : 1) }}<em class="bp-new-tag" v-if="h.latest">最新</em></td>
                            <td v-if="!buyHistoryAll">{{ fmt(h.share, 1) }}%</td>
                          </tr>
                          <tr v-if="!buyHistoryRows.length"><td colspan="8" class="bp-empty">
                            <template v-if="buyHistoryAll">{{ selectedMaterial }} 无历史成交记录（对账单中该材质一条成交都没有）</template>
                            <template v-else>{{ selectedMaterial }} 无历史成交记录{{ (厚 - 0) ? '（厚度 ' + 厚 + ' mm）' : '' }}，也没有可搬的通用预测参考档</template>
                          </td></tr>
                        </tbody>
                      </table>
                    </div>
                    <p class="bp-note" v-if="buyHistoryAll">当前<b class="bp-all-word">未筛选厚度</b>，所以上表把{{ buyHistoryCrossMat ? '全部材质' : selectedMaterial }}的所有历史成交按<b>成交日期倒序</b>列出，供逐条核对；「距最新」＝距{{ buyHistoryCrossMat ? '全数据集' : selectedMaterial }}最近一次买料的天数。填入厚度后会立即切到<b>预测口径</b>：只取「同材质 + 同厚度」的成交，按「面积接近度 × <b class="bp-time-text">时间新度</b>」加权平均并按权重降序列出（含时间权重与权重占比）。数据源：原始 {{ buyModel.source.rawRecords }} 条 → 合并同规格 {{ buyModel.source.dupRemoved }} 条 → 剔离群 {{ buyOutlierCount }} 条 → 有效 {{ buyModel.source.records }} 条。口径：{{ buyModel.source.scope }}。<b class="bp-warn-text">{{ buyModel.source.caveat }}</b></p>
                    <p class="bp-note" v-else-if="buyIsGeneric">通用预测吨价 = 上表记录（<b class="bp-generic-word">搬自 {{ buyPredict.ref.material }} {{ buyPredict.ref.thickness }} mm 的 {{ buyPredict.poolCount }} 条同材质成交</b>，因 {{ selectedMaterial }} 无 {{ 厚 }} mm 成交记录）按「面积接近度 × <b class="bp-time-text">时间新度</b>」加权平均；<b class="bp-time-text">同尺寸下成交日期越近权重越高</b>，最新 {{ buyPredict.latestDate }} 按 ×{{ buyModel.timeBoost }} 计权、最早 {{ buyPredict.oldestDate }} 按 ×1；<b>同材质 + 同厚度 + 同尺寸的成交记录只保留最新一条</b>（已合并 {{ buyDupCount }} 条重复规格），吨价离群已剔除 {{ buyOutlierCount }} 条。<b class="bp-generic-word">通用预测只在同材质内取数（不跨材质），但厚度与本次不同，只能作量级参考，不能当作 {{ 厚 }} mm 的真实成交价。</b>口径：{{ buyModel.source.scope }}。<b class="bp-warn-text">{{ buyModel.source.caveat }}</b></p>
                    <p class="bp-note" v-else>预测吨价 = 上表记录（<b>全部为 {{ selectedMaterial }} {{ 厚 || '—' }} mm 的同材质同厚度成交</b>）按「面积接近度 × <b class="bp-time-text">时间新度</b>」加权平均；<b class="bp-time-text">同尺寸下成交日期越近权重越高</b>，最新 {{ buyPredict.latestDate }} 按 ×{{ buyModel.timeBoost }} 计权、最早 {{ buyPredict.oldestDate }} 按 ×1；<b>同材质 + 同厚度 + 同尺寸的成交记录只保留最新一条</b>（已合并 {{ buyDupCount }} 条重复规格），吨价离群已剔除 {{ buyOutlierCount }} 条。口径：{{ buyModel.source.scope }}。<b class="bp-warn-text">{{ buyModel.source.caveat }}</b></p>
                    <div class="bp-files">
                      <span>数据源文件：</span>
                      <em v-for="f in buyModel.source.files" :key="f">{{ f }}</em>
                    </div>
                  </div>

                  <!-- 价格参考来源明细 -->
                  <div class="bp-src-title">
                    价格参考来源明细
                    <span>每个预测数字都标注了来源，可逐项核对</span>
                  </div>

                  <div class="bp-src-grid">
                    <!-- ① 历史成交加权（主口径） -->
                    <div class="bp-card">
                      <h5><i>①</i>每吨价 · 历史成交加权（{{ buyHistoryAll ? '未筛厚度 · 该材质全部成交' : (buyIsGeneric ? '通用预测 · 同材质样本最多档' : '精确预测 · 同材质同厚度') }}）</h5>
                      <div class="bp-kv" v-if="buyIsGeneric"><span>命中层级</span><b><b class="bp-generic-word">通用预测</b>：{{ selectedMaterial }} 无 {{ 厚 }} mm 成交记录，退回历史成交记录，搬同材质成交最多的 <b>{{ buyPredict.ref.material }} {{ buyPredict.ref.thickness }} mm（{{ buyPredict.ref.count }} 条）</b></b></div>
                      <div class="bp-kv"><span>加权口径</span><b v-if="buyHistoryAll">未填厚度，暂无预测值；下方面积档按「{{ selectedMaterial }} 全部成交」统计，供先看分布再定厚度</b><b v-else-if="buyIsGeneric">取「{{ buyPredict.ref.material }} + {{ buyPredict.ref.thickness }} mm」的成交记录，按「面积接近度 × 时间新度」加权平均</b><b v-else>只取「{{ selectedMaterial }} + {{ 厚 || '—' }} mm」的成交记录，按「面积接近度 × 时间新度」加权平均</b></div>
                      <div class="bp-kv"><span>筛选规则</span><b v-if="buyIsGeneric"><b class="bp-generic-word">通用预测只在同材质内取数（不跨材质）</b>，但厚度与本次不同，只作量级参考；也不做理论外推</b><b v-else-if="buyHistoryAll">未填厚度＝未筛选，下方面积档不过滤厚度；填入厚度后只认「同材质 + 同厚度」成交</b><b v-else><b class="bp-stale-word">不同材质、不同厚度的成交不参与精确预测</b>，不做跨厚度插值/外推</b></div>
                      <div class="bp-kv"><span>时间新度</span><b v-if="buyHistoryAll">未填厚度，暂无预测值；{{ selectedMaterial }} 全部成交的日期跨度 {{ buyHistoryView.oldestDate }} ~ {{ buyHistoryView.latestDate }}</b><b v-else>日期越近权重越高：{{ buyPredict.oldestDate }} ×1 → {{ buyPredict.latestDate }} ×{{ buyModel.timeBoost }}（上限 {{ buyModel.timeBoost }} 倍）</b></div>
                      <div class="bp-kv" v-if="buyHistoryAll"><span>本次代入</span><b>未填厚度，暂无预测值（下方面积档为该材质全部成交的分布）</b></div>
                      <div class="bp-kv" v-else><span>本次代入</span><b>{{ selectedMaterial }} · 单件 {{ 平方 | toFixed4 }}㎡ · 厚 {{ 厚 || 0 }}mm → {{ fmt(buyPerTon, 0) }} 元/t<template v-if="buyPerSqmIsMain">（≤{{ buyModel.thinThick }}mm 按平方：<b class="hl-thin">{{ fmt(buyPerSqm, 2) }} 元/㎡</b>）</template><template v-else-if="buyIsGeneric">（参考每平方价按 {{ buyPredict.ref.thickness }}mm 换算：<b class="hl-thin">{{ fmt(buyPerSqm, 2) }} 元/㎡</b>）</template></b></div>
                      <div class="bp-kv"><span>平方价换算</span><b v-if="buyIsGeneric">元/㎡ = 元/t × <b>参考档厚度 {{ buyPredict.ref.thickness }}mm</b> × 密度 {{ fmt(密度 * 10, 2) }} ÷ 1000；因吨价搬自 {{ buyPredict.ref.thickness }}mm 档，平方价也必须按该档厚度换算才是同一口径</b><b v-else>元/㎡ = 元/t × 厚(mm) × 密度 {{ fmt(密度 * 10, 2) }} ÷ 1000；只取同厚度记录，厚与密度为常数，吨价加权与平方价加权等价</b></div>
                      <div class="bp-kv"><span>参与样本</span><b v-if="buyHistoryAll">{{ buyHistoryView.poolCount }} 条（{{ selectedMaterial }} 全部有效成交，未筛厚度）</b><b v-else-if="buyIsGeneric">{{ buyPredict.poolCount }} 条（{{ buyPredict.ref.material }} {{ buyPredict.ref.thickness }} mm 参考档的全部有效成交）</b><b v-else>{{ buyPredict.poolCount }} 条（{{ selectedMaterial }} {{ 厚 || '—' }} mm 的全部有效成交）</b></div>
                      <div class="bp-kv"><span>模型验证</span><b>时间切分（只用更早成交预测更晚成交）MAPE {{ buyModel.valSplitMape }}% · 逐条留一 MAPE {{ buyModel.valLooMape }}%（中位 {{ buyModel.valLooMedian }}%）· 有效样本 {{ buyModel.source.records }} 条（{{ buyModel.source.range }}）</b></div>
                      <div class="bp-kv"><span>数据源</span><b>原始 {{ buyModel.source.rawRecords }} 条 → 合并同规格 {{ buyModel.source.dupRemoved }} 条 → 有效 {{ buyModel.source.records }} 条 · {{ buyModel.source.area }}㎡ · {{ buyModel.source.weight }}t · {{ buyModel.source.amount }}元</b></div>
                      <table class="bp-table">
                        <thead><tr><th>面积档</th><th>条数</th><th>该档吨价区间</th><th>最近成交</th></tr></thead>
                        <tbody>
                          <tr v-for="b in buySameThickStat" :key="b.label" :class="{ 'bp-active': b.label === buyAreaBand.label }">
                            <td>{{ b.label }}<span class="bp-same-tag" v-if="b.label === buyAreaBand.label">本次</span></td>
                            <td>{{ b.count || '—' }}</td>
                            <td><template v-if="b.count">{{ b.min === b.max ? b.min + ' 元/t' : b.min + ' ~ ' + b.max + ' 元/t' }}</template><template v-else>无成交</template></td>
                            <td>{{ b.latest || '—' }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <p class="bp-note">面积越接近本次单件面积，权重越高（面积平滑量 {{ buyModel.areaSmooth }} ㎡）；<b class="bp-time-text">成交日期越近权重越高（{{ buyModel.timeBoost }} 倍上限）</b>。上表是<b>{{ buyHistoryAll ? selectedMaterial + ' 全部成交（未筛厚度）' : (buyIsGeneric ? '通用预测参考档' : '该厚度') }}</b>各面积档的真实成交区间，用于判断预测值是否合理。<b>{{ buyIsGeneric ? '通用预测只做同材质内取数，跨了厚度，也不使用任何理论单价公式外推。' : (buyHistoryAll ? '填入厚度后才会给出预测值；未填厚度时本表只做分布展示，不参与任何加权计算。' : '不同材质、不同厚度均不参与精确预测，也不使用任何理论单价公式外推。') }}</b></p>
                    </div>

                    <!-- ② 市场对标 -->
                    <div class="bp-card">
                      <h5><i>②</i>市场对标 · 我的钢铁网</h5>
                      <table class="bp-table">
                        <thead><tr><th>品种</th><th>价格</th><th>日期</th><th>地区</th></tr></thead>
                        <tbody>
                          <tr v-for="m in buyModel.market" :key="m.name">
                            <td>{{ m.name }}</td>
                            <td class="bp-hl">{{ m.price }} 元/t</td>
                            <td>{{ m.date }}</td>
                            <td>{{ m.scope }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <p class="bp-note">用于校核：本次预测 {{ fmt(buyPerTon, 0) }} 元/t（理论重量口径），对应南宁热卷 {{ buyModel.market[0].price }} 元/t。</p>
                    </div>

                  </div>
                </div>
                <!-- ================== 价格预测 END ================== -->
              </div>
            </slide-x-left-transition>
          </div>
        </div>
      </div>
    </slide-x-left-transition>
  </div>
</template>

<script>
import E from 'wangeditor'
import '../components/wangeditor.css'

import util, {isImage} from "@/util";
import orderModel from "@/assets/models/order";

import moment from 'moment'
import print from 'vue-print-nb'
import orderItemModel from "@/assets/models/OrderItem";
import html2canvas from 'html2canvas'
// 钢材买料价格预测模型（对账单口径）：数据 + 算法唯一实现，与 LaserOrderDialog 报价明细共用
import {
  PRICE_MODEL,
  PRICE_HISTORY,
  CLEAN_HISTORY,
  DUP_COUNT,
  OUTLIER_COUNT,
  predictSteelPrice,
  historyRowsFor
} from '@/utils/steelPricePredict'

window.moment = moment;

let canvas = null, ctx = null,
    errorMessage = null, infoMessage = null

// 打印图纸「转为 canvas（反色）」用的原图 blob 缓存（key = 图片 URL），
// 避免反复点同一个按钮时重复下载。与 LaserOrderDialog 里的 printImgBlobCache 同构。
const calcPrintImgBlobCache = new Map()

function validFormTmp () {
  this.validForm()
}

function _loadUserPic (id) {
  this.loadUserPic(id)
}

const handlePaste = e => {
  if (!e.clipboardData || !e.clipboardData.items || !window.$laserOrderDialog.isShowThis) {
    return;
  }
  let file = false;
  for (let i = 0, len = e.clipboardData.items.length; i < len; i++) {
    let item = e.clipboardData.items[i];
    console.log('paste:', item)
    // if (/image/.test(item.type)) {
    if (item.kind === 'file') {
      file = item.getAsFile();
    }
  }
  console.log('pre upload file: ', file);
  if (file)
    window.$laserOrderDialog.uploadImg.call(this, file)
}
const handleKeyDown = e => {
  let v = window.$laserOrderDialog || window.$laserOrderDialog.$refs.imgViewer.viewer
  if (v !== null && v.isShown) return;
  if (window.$laserOrderDialog.curEditField) return;
  if (e.key === 'ArrowRight') window.$laserOrderDialog.orderChange(1)
  if (e.key === 'ArrowLeft') window.$laserOrderDialog.orderChange(-1)
}

export default {
  directives: {print},
  data () {
    return {
      order: {},
      isShowThis: false,
      isUserLoading: false,
      userListCurrentType: '',
      userList: {
        order: [],
        outbound: [],
        customer: []
      },
      apiFilter: {
        name: ''
      },
      loading: {
        userList: false,
        order: false,
        orderUpdate: false,
        orderUpdateRecord: false
      },
      show: {
        selectorCustomerUser: false,
        selectorCreateUser: false,
        selectorOutboundUser: false,
        pics: {},
        orderItemDelBtn: [],
        orderItemIsEdit: [],
        printCanvas: [],
        printCanvasBtns: [],
        isRandomMoney: true
      },
      title: {width: 200, height: 40},
      pickdateField: '',
      curEditor: null,
      curEditField: null,
      curSavingField: null,
      tmpValue: '',
      isOpenDatePickr: false,
      err: {},
      errMsg: {},
      isFormValid: false,
      isShowStatus: false,
      queueRemaining: 0,
      userPic: {
        customer: {
          money: 0,
          total: 0
        }
      },
      recordList: null,
      page: {
        index: undefined,
        total: 0,
        hasNext: false,
        hasPrev: false,
      },
      printObj: {
        id: "print-content",
        popTitle: '.',
      },
      isPrintModel: false,
      printImgs: [],
      长: 0,
      宽: 0,
      厚: 0,
      密度: 0.785,
      单价: 4500,
      平方: 0,
      结果: 0,
      价格预设1: 0,
      价格预设2: 0,
      价格预设3: 0,
      价格预设4: 0,
      selectedMaterial: '铁板',
      总价: '',           // 新增总价字段
      每公斤价格: 0,       // 新增每公斤价格字段
      uniqueId: Math.random().toString(36).substr(2, 9),

      // ==== 买料价格预测模型数据（2026-09-22 外置到 src/utils/steelPricePredict.js）====
      // 数据与算法唯一实现在 @/utils/steelPricePredict.js，与 LaserOrderDialog（报价明细 Th 列预测吨价）共用同一份，
      // 保证两处预测结果完全一致；改模型请改那个文件，不要在本组件里再复制一份数据。
      buyModel: PRICE_MODEL,
      buyHistory: PRICE_HISTORY,
      // 材质×厚度 加权吨价 [材质, 厚度, 件数, 面积, 金额, 每吨价]
      buyThStat: [
        ["碳钢",1,4,4.12,256,7906],
        ["镀锌板",1,2,6.10,200,4177],
        ["碳钢",1.2,1,0.78,43,5850],
        ["碳钢",1.5,3,5.65,345,5182],
        ["镀锌板",1.5,1,0.53,34,5484],
        ["碳钢",2,12,11.79,823,4445],
        ["镀锌板",2,1,0.35,29,5204],
        ["碳钢",2.5,5,9.79,809,4210],
        ["碳钢",2.75,1,1.10,104,4371],
        ["碳钢",3,17,15.80,1451,3899],
        ["锰板",3,5,3.30,345,4436],
        ["镀锌板",3,1,0.20,20,4188],
        ["碳钢",4,12,21.44,2318,3444],
        ["锰板",4,4,3.96,518,4170],
        ["碳钢",5,18,26.76,3715,3537],
        ["锰板",5,5,1.06,165,3971],
        ["碳钢",6,12,44.25,6941,3330],
        ["锰板",6,3,1.70,319,3991],
      ],
    }
  },
  inject: ['componentXuqiu'],
  computed: {
    user () {
      return this.$store.state.user;
    },
    isCreate () {
      return !this.order.id;
    },
    // ==================== 买料价格预测（主口径：纯历史成交加权） ====================
    // 去重 / 离群剔除 / 时间跨度这些都已在 @/utils/steelPricePredict.js 模块加载时算好，
    // 此处只做引用；同一套规则不在组件里重写，避免两处口径漂移。
    buyDupCount () {
      return DUP_COUNT
    },
    buyHistoryClean () {
      return CLEAN_HISTORY
    },
    // 被剔除的离群条数（去重后仍未通过中位数区间检验的）
    buyOutlierCount () {
      return OUTLIER_COUNT
    },
    // 该材质历史记录覆盖的厚度档
    buyThicknessList () {
      const list = []
      this.buyHistoryClean.forEach(item => {
        if (item[1] === this.selectedMaterial && list.indexOf(item[3]) === -1) list.push(item[3])
      })
      return list.sort((x, y) => x - y)
    },
    // 可预测组合总览：按材质列出有历史成交的厚度档（条数 / 最近成交 / 吨价区间），供快速查看
    buyCoverage () {
      const groups = {}
      this.buyHistoryClean.forEach(item => {
        const mat = item[1]
        if (!groups[mat]) groups[mat] = {}
        const key = String(item[3])
        if (!groups[mat][key]) groups[mat][key] = { thick: item[3], count: 0, latest: '', prices: [] }
        const item0 = groups[mat][key]
        item0.count++
        item0.prices.push(item[7])
        if (!item0.latest || this.buyDayIndex(item[0]) > this.buyDayIndex(item0.latest)) item0.latest = item[0]
      })
      return this.buyModel.matOrder.map(mat => {
        const group = groups[mat] || {}
        const items = Object.keys(group).map(key => {
          const one = group[key]
          const sorted = one.prices.slice().sort((x, y) => x - y)
          return {
            thick: one.thick,
            count: one.count,
            latest: one.latest,
            daysAgo: this.buyDaysAgo(one.latest),
            pmin: sorted[0],
            pmax: sorted[sorted.length - 1],
            pmed: sorted[Math.floor(sorted.length / 2)]
          }
        }).sort((x, y) => y.thick - x.thick)
        return {
          mat: mat,
          items: items,
          count: items.reduce((sum, one) => sum + one.count, 0)
        }
      })
    },
    // 有成交数据的「材质 + 厚度」组合总数
    buyCoverageCombos () {
      return this.buyCoverage.reduce((sum, one) => sum + one.items.length, 0)
    },
    // 当前单件面积所属的面积档
    buyAreaBand () {
      const area = this.平方 - 0
      const bands = this.buyModel.areaBand
      for (let i = 0; i < bands.length; i++) {
        if (area >= bands[i].min && area < bands[i].max) return bands[i]
      }
      return bands[bands.length - 1]
    },
    // 各面积档的真实成交区间与条数（供来源卡①展示）
    //   填了厚度 → 统计「该材质 + 该厚度」的成交；
    //   没填厚度 → 不过滤厚度，统计该材质的全部成交（与「历史成交记录」面板的浏览口径一致）
    buySameThickStat () {
      const bands = PRICE_MODEL.areaBand
      const stat = bands.map(band => ({ label: band.label, min: null, max: null, count: 0, latest: '' }))
      const pool = this.buyPredictPool.length
        ? this.buyPredictPool
        : this.buyHistoryRows.map(one => one.row)
      pool.forEach(item => {
        for (let i = 0; i < bands.length; i++) {
          if (item[4] >= bands[i].min && item[4] < bands[i].max) {
            const one = stat[i]
            if (one.min === null || item[7] < one.min) one.min = item[7]
            if (one.max === null || item[7] > one.max) one.max = item[7]
            if (!one.latest || this.buyDayIndex(item[0]) > this.buyDayIndex(one.latest)) one.latest = item[0]
            one.count++
            break
          }
        }
      })
      return stat
    },
    // ===== 价格预测（唯一实现在 @/utils/steelPricePredict.js，与 LaserOrderDialog 报价明细共用）=====
    // 命中顺序：① 精确层（同材质 + 同厚度成交加权）→ ② 通用层（同材质样本最多档）→ ③ 无法预测
    buyPredict () {
      return predictSteelPrice({
        material: this.selectedMaterial,
        thickness: this.厚 - 0,
        area: this.平方 - 0,
        density: this.密度 * 10
      })
    },
    // 命中的是精确层：同材质 + 同厚度有成交记录
    buyHasHist () {
      return this.buyPredict.level === 'exact'
    },
    // 命中的是通用层：该厚度无成交，搬同材质样本最多档的加权价
    buyIsGeneric () {
      return this.buyPredict.level === 'generic'
    },
    // 是否有预测结果（精确层或通用层任一命中）
    buyPredictOk () {
      return this.buyPredict.ok
    },
    // 本次预测实际使用的成交样本（精确层＝同厚度成交；通用层＝参考档成交）
    buyPredictPool () {
      return this.buyPredict.rows.map(one => one.row)
    },
    // 「历史成交记录 · 预测依据」面板取数：
    //   填了厚度 → 与预测同源（精确层 / 通用层的同一批记录）
    //   没填厚度 → 不过滤厚度，列出该材质（该材质无记录时列出全部材质）的全部历史成交
    buyHistoryView () {
      return historyRowsFor({
        material: this.selectedMaterial,
        thickness: this.厚 - 0,
        area: this.平方 - 0,
        density: this.密度 * 10
      })
    },
    // 是否处于「不填厚度 → 列出全部记录」的浏览模式
    buyHistoryAll () {
      return this.buyHistoryView.scope === 'all' || this.buyHistoryView.scope === 'allMat'
    },
    // 浏览模式下跨了材质（当前材质一条成交都没有，退化为列出全部材质）
    buyHistoryCrossMat () {
      return this.buyHistoryView.scope === 'allMat'
    },
    buyHistoryRows () {
      return this.buyHistoryView.rows
    },
    // 预测吨价
    buyPerTon () {
      return this.buyPredict.ok ? this.buyPredict.perTon : 0
    },
    // 是否按平方计价：厚度 ≤ 3mm 的薄板，行业习惯按面积（元/㎡）报价
    buyIsThin () {
      const thickValue = this.厚 - 0
      return thickValue > 0 && thickValue <= PRICE_MODEL.thinThick
    },
    // 每平方价 元/㎡ = 每吨价 × 厚(mm) × 密度(t/m³) ÷ 1000
    // 精确层：只取同厚度记录，厚与密度在档内为常数，故「吨价加权」与「平方价加权」结果完全等价
    // 通用层：吨价搬自参考档，平方价必须按参考档厚度换算（模块内已处理），保证口径一致
    buyPerSqm () {
      return this.buyPredict.ok ? this.buyPredict.perSqm : 0
    },
    // 主口径归属：薄板(≤3mm)且命中精确层时才把每平方价当主口径；
    // 通用层的厚度对不上，一律以每吨价为主口径
    buyPerSqmIsMain () {
      return this.buyIsThin && !this.buyIsGeneric
    },
    buyPerTonIsMain () {
      return !this.buyPerSqmIsMain
    },
    // 样本可靠性提示
    buyMaterialWarn () {
      const mat = this.selectedMaterial
      const thickValue = this.厚 - 0
      const ths = this.buyThicknessList
      const pool = this.buyPredictPool
      if (!thickValue || thickValue <= 0) {
        return ths.length
          ? mat + ' 现有成交厚度：' + ths.join(' / ') + ' mm。只有同材质同厚度的成交才参与精确预测，请输入厚度'
          : (PRICE_MODEL.matNote[mat] || (mat + ' 无成交记录'))
      }
      if (this.buyIsGeneric) {
        const ref = this.buyPredict.ref
        return mat + ' 无 ' + thickValue + ' mm 的成交记录，已退回历史成交记录做通用预测：'
          + '搬用同材质样本最多的 ' + ref.material + ' ' + ref.thickness + ' mm（' + ref.count
          + ' 条）加权吨价。不跨材质，但跨了厚度，只作量级参考'
      }
      if (!pool.length) {
        return PRICE_MODEL.matNote[mat] || (mat + ' 无成交记录')
      }
      if (pool.length === 1) {
        return mat + ' ' + thickValue + ' mm 只有 1 条成交记录（' + pool[0][0] + ' ' + pool[0][2] + '），预测值即该条实价，仅为单一参考点'
      }
      if (pool.length < 5) {
        return mat + ' ' + thickValue + ' mm 成交样本仅 ' + pool.length + ' 条，结果可靠性偏低'
      }
      return ''
    },
    // 当前材质 + 厚度 + 同面积档的历史成交价区间（最低/最高及其对应记录）
    // 先取「同厚度 + 同面积档」（最可比），不足 2 条再回退到「同厚度全部」
    buyHistoryRange () {
      const sameThick = this.buyPredictPool
      if (!sameThick.length) return null
      const band = this.buyAreaBand
      const areaMatched = sameThick.filter(item => item[4] >= band.min && item[4] < band.max)
      const list = areaMatched.length >= 2 ? areaMatched : sameThick
      let minItem = list[0]
      let maxItem = list[0]
      list.forEach(item => {
        if (item[7] < minItem[7]) minItem = item
        if (item[7] > maxItem[7]) maxItem = item
      })
      return {
        min: minItem[7], max: maxItem[7], count: list.length,
        minItem: minItem, maxItem: maxItem,
        bandLabel: areaMatched.length >= 2 ? band.label : '该厚度全部面积',
        scoped: areaMatched.length >= 2
      }
    },
    // 预测值在历史区间中的位置（帮用户判断贵/便宜）
    buyRangePosition () {
      const range = this.buyHistoryRange
      if (!range || !this.buyPerTon) return ''
      if (this.buyPerTon < range.min * 0.98) return '低于区间下限'
      if (this.buyPerTon > range.max * 1.02) return '高于区间上限'
      if (this.buyPerTon < range.min) return '贴近区间下限'
      if (this.buyPerTon > range.max) return '贴近区间上限'
      const span = range.max - range.min
      if (!span) return '与历史成交一致'
      const ratio = (this.buyPerTon - range.min) / span
      if (ratio < 0.33) return '区间下部'
      if (ratio > 0.67) return '区间上部'
      return '区间中部'
    },
    // 计算过程文字：与 LaserOrderDialog 报价明细共用同一份（模块内拼好，两处口径一致）
    buyFormulaText () {
      const p = this.buyPredict
      if (!p.ok) return p.formulaText || '请输入长、宽、厚，自动给出价格预测'
      let line = p.formulaText
      if (p.level === 'generic') {
        return line + '　｜　参考每平方价按参考档 ' + p.ref.thickness + ' mm 换算：'
          + this.fmt(p.perTon, 0) + ' × ' + p.ref.thickness + ' × ' + this.fmt(this.密度 * 10, 2)
          + ' ÷ 1000 = ' + this.fmt(p.perSqm, 2) + ' 元/㎡'
      }
      if (this.buyIsThin) {
        return line + '　｜　' + (this.厚 - 0) + ' mm ≤ ' + PRICE_MODEL.thinThick + ' mm 按平方计价：'
          + this.fmt(p.perTon, 0) + ' × ' + (this.厚 - 0) + ' × ' + this.fmt(this.密度 * 10, 2)
          + ' ÷ 1000 = ' + this.fmt(p.perSqm, 2) + ' 元/㎡'
      }
      return line + '（每平方价 ' + this.fmt(p.perSqm, 2) + ' 元/㎡）'
    },
    // showPrev () {
    //   if (!window.$xuQiu || !window.$xuQiu.realList) return false
    //   let index = window.$xuQiu.realList.findIndex(item => item.id === this.order.id)
    //   return index !== -1 && index !== 0
    // },
    // showNext () {
    //   if (!window.$xuQiu || !window.$xuQiu.realList) return false
    //   let index = window.$xuQiu.realList.findIndex(item => item.id === this.order.id)
    //   return index !== -1 && index !== window.$xuQiu.realList.length - 1
    // }
  },
  methods: {
    // 日期字符串 "YYYY-MM-DD" → 天序号（用于比较与归一化）
    buyDayIndex (dateText) {
      const parts = String(dateText || '').split('-')
      if (parts.length !== 3) return 0
      return Date.UTC(parts[0] - 0, parts[1] - 0 - 1, parts[2] - 0) / 86400000
    },
    // 距离今天的天数（用于标注成交数据的时效）
    buyDaysAgo (dateText) {
      const diff = Date.now() / 86400000 - this.buyDayIndex(dateText)
      return Math.max(0, Math.round(diff))
    },
    // 点可预测组合总览里的厚度胶囊 → 直接填入该材质 + 厚度
    pickCoverage (material, thick) {
      if (this.selectedMaterial !== material) {
        this.selectedMaterial = material
        this.密度 = material === '不锈钢' ? 0.791 : 0.785
      }
      this.厚 = String(thick)
      this.submit()
    },
    setMaterial(material) {
      // 密度对齐 LaserOrderDialog.materialDensityOf（行内口径 = t/m³ ÷ 10）：
      // 仅不锈钢 0.791；铁板(碳钢) / 锰板 / 镀锌 均 0.785
      this.密度 = material === '不锈钢' ? 0.791 : 0.785;
      this.submit();
    },
    drawShape () {
      // 清除画布和消息
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      errorMessage.textContent = '';
      infoMessage.textContent = '';

      // 获取输入值
      const widthValue = this.宽
      const heightValue = this.长

      // 检查是否绘制圆形（高度未输入）
      if (heightValue === '') {
        if (widthValue === '') {
          errorMessage.textContent = '请输入直径值';
          return;
        }

        const diameter = parseInt(widthValue);
        if (isNaN(diameter)) {
          errorMessage.textContent = '请输入有效的直径值';
          return;
        }

        this.drawCircle(diameter);
        infoMessage.textContent = '正在绘制圆形，直径: ' + diameter + 'px';
      }
      // 否则绘制长方形
      else {
        if (widthValue === '') {
          errorMessage.textContent = '请输入宽度值';
          return;
        }

        const width = parseInt(widthValue);
        const height = parseInt(heightValue);

        if (isNaN(width) || isNaN(height)) {
          errorMessage.textContent = '请输入有效的宽度和高度值';
          return;
        }

        this.drawRectangle(width, height);
        infoMessage.textContent = '正在绘制长方形，宽度: ' + width + 'px, 高度: ' + height + 'px';
      }
    },
    drawCircle (diameter) {
      // 检查是否超出画布（留出更多空间给标注）
      const padding = 60;
      const maxVisibleSize = Math.min(canvas.width, canvas.height) - padding * 2;

      let scale = 1;
      if (diameter > maxVisibleSize) {
        scale = maxVisibleSize / diameter * 0.95; // 额外缩小5%确保完全可见
        infoMessage.textContent += ` (已缩放 ${(scale * 100).toFixed(0)}%)`;
      }

      const displayDiameter = diameter * scale;
      const radius = displayDiameter / 2;

      // 计算绘制位置（居中）
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;

      // 绘制黑色圆形
      ctx.beginPath();
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 2;
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      ctx.stroke();

      // 设置标注样式
      ctx.strokeStyle = 'red';
      ctx.fillStyle = 'red';
      ctx.lineWidth = 1;
      ctx.font = '12px Arial';
      ctx.textAlign = 'center';

      // 标注直径（水平方向）
      const startX = centerX - radius;
      const endX = centerX + radius;
      const lineY = centerY + radius + 30;

      // 确保标注线不会超出画布
      const adjustedLineY = Math.min(lineY, canvas.height - 20);

      this.drawDimensionLine(
          ctx,
          startX, adjustedLineY,
          endX, adjustedLineY,
          diameter + 'px',
          'top'
      );
    },
    drawRectangle (width, height) {
      // 检查是否超出画布（留出更多空间给标注）
      const padding = 60;
      const maxVisibleWidth = canvas.width - padding * 2;
      const maxVisibleHeight = canvas.height - padding * 2;

      let scale = 1;
      if (width > maxVisibleWidth || height > maxVisibleHeight) {
        scale = Math.min(maxVisibleWidth / width, maxVisibleHeight / height) * 0.95;
        infoMessage.textContent += ` (已缩放 ${(scale * 100).toFixed(0)}%)`;
      }

      const displayWidth = width * scale;
      const displayHeight = height * scale;

      // 计算绘制位置（居中）
      const startX = (canvas.width - displayWidth) / 2;
      const startY = (canvas.height - displayHeight) / 2;

      // 绘制黑色长方形
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 2;
      ctx.strokeRect(startX, startY, displayWidth, displayHeight);

      // 设置标注样式
      ctx.strokeStyle = 'red';
      ctx.fillStyle = 'red';
      ctx.lineWidth = 1;
      ctx.font = '12px Arial';
      ctx.textAlign = 'center';

      // 标注宽度
      const widthLineY = Math.min(startY + displayHeight + 30, canvas.height - 20);
      this.drawDimensionLine(
          ctx,
          startX, widthLineY,
          startX + displayWidth, widthLineY,
          width + 'px',
          'top'
      );

      // 标注高度
      const heightLineX = Math.max(startX - 30, 20);
      this.drawDimensionLine(
          ctx,
          heightLineX, startY,
          heightLineX, startY + displayHeight,
          height + 'px',
          'left'
      );
    },
    // 绘制标注线的函数
    drawDimensionLine (ctx, x1, y1, x2, y2, text, position) {
      // 绘制主标注线
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();

      // 绘制两端的短标记线
      const markerLength = 10;

      if (position === 'top' || position === 'bottom') {
        // 水平标注线
        ctx.beginPath();
        ctx.moveTo(x1, y1 - markerLength / 2);
        ctx.lineTo(x1, y1 + markerLength / 2);
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(x2, y2 - markerLength / 2);
        ctx.lineTo(x2, y2 + markerLength / 2);
        ctx.stroke();

        // 绘制标注文字
        ctx.fillText(text, (x1 + x2) / 2, y1 - 5);
      } else {
        // 垂直标注线
        ctx.beginPath();
        ctx.moveTo(x1 - markerLength / 2, y1);
        ctx.lineTo(x1 + markerLength / 2, y1);
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(x2 - markerLength / 2, y2);
        ctx.lineTo(x2 + markerLength / 2, y2);
        ctx.stroke();

        // 绘制标注文字
        ctx.save();
        ctx.translate(x1 - 15, (y1 + y2) / 2);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText(text, 0, 0);
        ctx.restore();
      }
    },
    submit () {
      if (!this.长) {
        this.平方 = Math.pow((this.宽 / 1000 / 2), 2) * Math.PI
      } else {
        this.平方 = (this.长 / 1000) * (this.宽 / 1000)
      }
      this.结果 = this.平方 * this.密度 * this.厚 / 100
      this.价格 = this.结果 * this.单价
      this.价格预设1 = this.结果 * 4500
      this.价格预设2 = this.结果 * 4200
      this.价格预设3 = this.结果 * 4000
      this.价格预设4 = this.结果 * 3800
      this.价格预设1 = this.价格预设1.toFixed(2)
      this.价格预设2 = this.价格预设2.toFixed(2)
      this.价格预设3 = this.价格预设3.toFixed(2)
      this.价格预设4 = this.价格预设4.toFixed(2)
      util.setStorage('js_cal', {
        长: this.长,
        宽: this.宽,
        厚: this.厚,
        密度: this.密度,
        单价: this.单价,
        材质: this.selectedMaterial
      })
      // 重新计算每公斤价格
      this.calculatePricePerKg();
      this.drawShape()
    },
    randomMoney (money) {
      let r = Math.random() * 100;
      while (r < 10) {
        r = Math.random() * 100
      }
      return parseInt(r) + '' + money
    },
    orderChange (changeIndex) {
      if (this.loading.order || ['title', 'createTime'].includes(this.curEditField)) return
      console.log('taskNext', changeIndex)
      // let index = window.$xuQiu.realList.findIndex(item => item.id === this.order.id)
      // if (index !== -1) {
      //   // 当最后一个订单不能再切换到下一个订单
      //   if (changeIndex === 1 && index !== window.$xuQiu.realList.length - 1) {
      //     this.loadOrder(window.$xuQiu.realList[index + 1].id)
      //   }
      //   // 当第一个订单不能再切换到上一个订单
      //   if (changeIndex === -1 && index !== 0) {
      //     this.loadOrder(window.$xuQiu.realList[index - 1].id)
      //   }
      // }
      if (changeIndex === 1 && this.page.hasNext || changeIndex === -1 && this.page.hasPrev) {
        this.page.index += changeIndex
        this.$router.replace({
          name: '激光订单',
          params: {
            id: this.order.id + '.' + parseInt(Math.random() * 100000),
            rowIndex: this.page.index,
            filter: this.$route.params.filter,
          }
        })
      }
    },
    setShowPics (i) {
      let temp = {};
      temp[i] = true;
      this.show.pics = Object.assign({}, this.show.pics, temp)
    },
    orderCreate () {
      this.isFormValid = true
      if (!this.validForm()) return
      let postData = util.clone(this.order)
      postData.pics = JSON.stringify(postData.pics)
      let t = new Date(postData.createTime).getTime()// + 8 * 60 * 60 * 1000
      t = new Date(t)
      postData.createTime = t.Format() + 'T' + t.Format('HH:mm:ss')
      postData.orderLoginUserId = this.user.id
      this.$post('/js-order/create', postData, () => {
        this.closeDialog()
        this.$nextTick(() => {
          window.$laserOrder.reloadData()
        })
      })
    },
    isImage (pic) {
      return isImage(pic)
    },
    viewPics (i, url) {
      if (isImage(url)) {
        this.$refs.imgViewer.init(this.order.pics, i)
      } else
        window.open(url)
    },
    openEditor (selector, field, event) {
      // 如果点击的是描述中的图片，那么只预览图片就好
      if (event.target.tagName === 'IMG') {
        let imgs = [];
        this.$('.html-content.w-e-text').find('img').each((i, img) => {
          imgs.push(this.$(img).attr('src'))
        })
        let curSrc = this.$(event.target).attr('src');
        console.log('open viewer:', imgs)
        let self = this;
        imgs = Array.from(imgs, item => self.img(item));
        this.$refs.imgViewer.init(imgs, imgs.indexOf(curSrc))
        return
      }
      if (field === 'orderDesc') {
        let menus = [
          'bold',  // 粗体
          'fontSize',  // 字号
          'italic',  // 斜体
          'underline',  // 下划线
          'foreColor',  // 文字颜色
          'link',  // 插入链接
          'list',  // 列表
          'justify',  // 对齐方式
          'image',  // 插入图片
          'video',  // 插入视频
          'undo',  // 撤销
          'redo'  // 重复
        ]
        this.curEditor = new E(selector)
        this.curEditor.config.menus = menus;
        this.curEditor.config.uploadImgMaxLength = 5;
        this.curEditor.config.customUploadImg = (resultFiles, insertImgFn) => {
          resultFiles.forEach(file => {
            const uploadOne = (cf) => {
              const ext = (cf.name && cf.name.indexOf('.') >= 0) ? cf.name.split('.').pop().toLowerCase() : (cf.type ? cf.type.split('/').pop() : 'png')
              this.$get('/oss/sign', { ext: ext, dir: 'img' }).then(sign => {
                const fd = new FormData()
                fd.append('key', sign.key)
                fd.append('OSSAccessKeyId', sign.ossAccessKeyId)
                fd.append('policy', sign.policy)
                fd.append('signature', sign.signature)
                fd.append('success_action_status', '200')
                fd.append('file', cf)
                this.$axios({ method: 'post', url: sign.host, data: fd, withCredentials: false }).then(() => {
                  insertImgFn(sign.url)
                }).catch(e => { console.error('wangEditor OSS 上传失败', e); this.$msg('图片上传失败', 'error') })
              }).catch(e => { console.error('获取签名失败', e); this.$msg('获取上传签名失败', 'error') })
            }
            // 原图直传 OSS（不压缩，保证质量）
            uploadOne(file)
          })
        }
        this.curEditor.create()
        this.curEditor.txt.html(this.order[field])
        this.tmpValue = this.order[field]
        this.curEditField = field
      }
    },
    cancelEditor () {
      this.order[this.curEditField] = this.tmpValue;
      this.curEditor.destroy()
      this.curEditor = null
      this.curEditField = null
    },
    destroyEditor () {
      if (this.curEditor) {
        this.curEditor.destroy()
        this.curEditor = null
        this.curEditField = null
        this.curSavingField = null
        this.tmpValue = ''
      }
    },
    submitEditor () {
      if (!this.curEditor) return
      this.order[this.curEditField] = this.curEditor.txt.html();
      if (!this.isCreate) {
        if (this.curSavingField) return
        this.curSavingField = this.curEditField;
        this.orderUpdate().then(() => {
          this.destroyEditor()
        }).catch(() => {
          this.destroyEditor()
        })
      } else
        this.destroyEditor()
    },
    isEditing (field, index) {
      return this.curEditField === field || typeof index === 'number' && this.curEditField && this.curEditField[field] === index;
    },
    isSaving (field) {
      return this.curSavingField === field;
    },
    cancelEdit () {
      this.order[this.curEditField] = this.tmpValue;
      this.curEditField = null;
    },
    openEdit (field) {
      this.tmpValue = this.order[field];
      this.curEditField = field;
    },
    submitEdit () {
      let self = this;

      function endEdit () {
        self.tmpValue = '';
        self.curSavingField = null;
        self.curEditField = null;
      }

      if (self.order.id) {
        if (self.curSavingField) return
        self.curSavingField = self.curEditField;
        self.orderUpdate().then(endEdit).catch(() => {
          self.order[self.curSavingField] = self.tmpValue
          endEdit();
        })
      } else
        endEdit(self)
    },
    movePics (picIndex, move) {
      let temp = this.order.pics[picIndex]
      this.order.pics[picIndex] = this.order.pics[picIndex + move]
      this.order.pics[picIndex + move] = temp
      this.submitEdit()
    },
    deletePic (i) {
      this.order.pics.splice(i, 1)
      this.submitEdit()
    },
    titleEdit () {
      // if (!this.isCreate) return
      // let $h1 = this.$('.l h1').eq(0);
      // this.title.width = $h1.width() - 2;
      // this.title.height = $h1.height() - 2;
      // this.title.width = '100%'
      setTimeout(() => {
        this.$refs.title.focus()
        this.$refs.title.select()
      }, 50)
      this.openEdit('title')
    },
    editMoney () {
      this.openEdit('money')
      setTimeout(() => {
        this.$refs.money.focus()
        this.$refs.money.select()
      }, 50)
    },
    editOrderItemMoney (index) {
      this.openEdit('orderItemMoney' + index)

      this.tmpValue = this.order.items[index].money
      this.curEditField = {orderItemMoney: index}
      setTimeout(() => {
        this.$refs.orderItemMoney[index].focus()
        this.$refs.orderItemMoney[index].select()
      }, 50)
    },
    editCreateTime () {
      this.openEdit('createTime')
      setTimeout(() => {
        this.$refs.createTime.focus()
        this.$refs.createTime.select()
      }, 50)
    },
    closeDialog () {
      // this.componentXuqiu.loadData();
      this.$router.push('/js')
      // this.$router.back()
    },
    closeAll () {
      if (this.curEditField) {
        console.log('close all')
        this.submitEdit()
      }
      // if (['createUserId', 'status', 'customerUserId'].indexOf(this.curEditField) !== -1)
      //   this.curEditField = null
    },
    loadUser (query) {
      let type = this.userListCurrentType
      this.loading.userList = true
      const roleId = {
        order: 6,
        outbound: 2
      }
      this.$get('/user/list/last-online', {name: query, roleId: roleId[type]}, (res) => {
        this.userList[type] = res;
        this.loading.userList = false
      })
    },
    handleClickSpanUser (key, index) {
      this.userListCurrentType = {
        'selectorCreateUser': 'order',
        'selectorOutboundUser': 'outbound',
        'selectorCustomerUser': 'customer'
      }[key]
      if (!this.userListCurrentType) this.userListCurrentType = 'outbound'
      this.loadUser()
      this.$set(this.show, key, true)
      setTimeout(() => {
        if (typeof index === 'number')
          this.$refs.selectorOutboundUser[index].focus()
        else
          this.$refs[key].focus()
      }, 50)
    },
    // userId=1 key=createUser selectorKey=selectorCreateUser
    setSpanUser (userId, key, selectorKey) {
      this.order[key] = this.userList[this.userListCurrentType].filter(item => item.id === userId)[0]
      this.order[key + "Id"] = userId
      this.show[selectorKey] = false
      this.submitEdit()
      this.closeAll()
    },
    // userId=1 key=outboundUser selectorKey=selectorOutboundUser
    setSpanUserByOrderItem (userId, key, selectorKey, itemIndex) {
      this.order.items[itemIndex].outboundUser = this.userList[this.userListCurrentType].filter(item => item.id === userId)[0]
      this.order.items[itemIndex].outboundUserId = userId
      this.show[selectorKey + itemIndex] = false
      this.submitEdit()
      this.closeAll()
    },
    orderUpdate () {
      return new Promise((resolve, reject) => {
        if (this.loading.orderUpdate)
          reject()
        this.isFormValid = true
        if (!this.validForm()) {
          this.$msg('请填写必填项', 'error')
          reject()
        } else {
          this.loading.orderUpdate = true
          let postData = Object.assign({}, this.order)
          postData.pics = JSON.stringify(postData.pics)
          this.$post('/js-order/update?userId=' + this.user.id, postData, res => {
            // this.componentXuqiu.loadData();
            res.data.pics = JSON.parse(res.data.pics)
            this.order = res.data
            this.loading.orderUpdate = false
            this.loadOrderUpdateRecord(this.order.id)
            window.$laserOrder.reloadData()
            resolve()
          }, () => {
            this.loading.orderUpdate = false
            reject()
          })
        }
      });
    },
    validForm () {
      let errTmp = {};
      let errMsgTmp = {};
      util.reg.notEmpty(this.order, 'title', errTmp, errMsgTmp)
      util.reg.notEmpty(this.order, 'createUserId', errTmp, errMsgTmp)
      util.reg.notEmpty(this.order, 'customerUserId', errTmp, errMsgTmp)
      this.err = Object.assign(this.err, errTmp)
      this.errMsg = Object.assign(this.errMsg, errMsgTmp)
      this.$forceUpdate()
      return !util.reg.hasError(this.err);
    },
    isErr (field) {
      return this.isFormValid && this.err[field];
    },
    isUrl (url) {
      return util.isUrl(url)
    },
    deleteOrder () {
      var self = this;
      let _layerConfirmId = self.$layer.confirm('删除后不可恢复，确认删除？', () => {
        self.$get('/js-order/del?userId=' + this.user.id, {id: this.order.id}, () => {
          self.$parent.loadData()
          self.closeDialog();
          self.$layer.close(_layerConfirmId)
        })
      })
    },
    copyOrder () {
      this.order.id = null
      this.$msg('订单复制成功')
      this.recordList = null
    },
    friendlyDate (date) {
      return util.friendlyDate1(date)
    },
    toDate (date) {
      return util.toDate(date)
    },
    fileChange () {
      let file = event.currentTarget.files[0];
      event.currentTarget.value = ''
      this.uploadImg(file)
    },
    async uploadImg (file) {
      if (!file) return
      // 原图直传 OSS（不压缩，保证图纸/照片质量）
      console.log('upload file', file)
      this.$uploadOss('/upload', {file: file, userId: this.user.id}, res => {
        console.log('upload:', res)
        this.order.pics.push(res[0])
        this.submitEdit()
      })
    },
    loadUserPic (id) {
      if (!id) return
      this.$get('/js-order/user-pic', {id: id}, res => {
        this.userPic.customer.money = res.money
        this.userPic.customer.total = res.total
      })
      validFormTmp.call(this)
    },
    loadOrderUpdateRecord (id) {
      this.loading.orderUpdateRecord = true
      this.$get('/js-order-update-record/list', {orderId: id}).then(res => {
        this.recordList = res
        this.loading.orderUpdateRecord = false
      })
    },
    loadOrder () {
      this.loading.order = true
      let promise
      console.log(JSON.parse(JSON.stringify(this.page)))
      if (!isNaN(this.page.index) && typeof this.page.index === 'number') {
        let filter = this.$route.params.filter
        filter.rowIndex = this.$route.params.rowIndex
        promise = this.$get('/js-order/get-by-index', filter)
      } else
        promise = this.$get('/js-order', {id: parseInt(this.$route.params.id)})

      promise.then(res => {
        if (typeof res.hasPrev !== 'boolean') {
          res = {
            hasNext: false,
            hasPrev: false,
            total: 1,
            order: res
          }
        }

        res.order.pics = JSON.parse(res.order.pics)
        this.page.hasPrev = res.hasPrev
        this.page.hasNext = res.hasNext
        this.page.total = res.total

        this.order = res.order
        this.isShowThis = true
        this.loading.order = false
        this.loadOrderUpdateRecord(this.order.id)

        // 仅仅为了记住地址,不进行页面上的跳转
        this.$router.replace({
          name: '激光订单',
          params: {
            id: this.order.id + '.' + parseInt(Math.random() * 100000 + ''),
            rowIndex: this.page.index,
            filter: this.$route.params.filter,
            onlyReplaceUrl: true
          }
        })
      })
    },
    handlePrintClick () {
      if (this.isPrintModel) {
        this.$refs.printBtn.click()
        this.$nextTick(() => {
          this.isPrintModel = false
        })
      } else {
        this.printImgs = JSON.parse(JSON.stringify(this.order.pics))
        this.isPrintModel = true
      }
    },
    printOrder () {
      // 原生的打印实现，将打印内容插入到body,打印完删除dom
      let target = document.getElementById('print-content')
      let content = document.createElement('div')
      content.id = 'printContent'
      content.innerHTML = target.innerHTML
      document.body.appendChild(content)
      window.print()
      document.body.removeChild(content)
    },
    order2Img () {
        // windowWidth: 1920,
        // windowHeight: 2715,
      html2canvas(document.getElementById('print-content'), {
        scale: 2,
        useCORS: true
      }).then(function (canvas) {
        // document.body.appendChild(canvas);
        // var image = document.getElementById('canvasImage');

        // 将Canvas内容转换为图片Data URL
        var dataURL = canvas.toDataURL('image/png');
        // 显示图片
        // image.src = dataURL;
        // 触发下载（可选）
        var link = document.createElement('a');
        link.href = dataURL;
        link.download = 'canvas_image.png';
        link.click();
      });
    },
    async outboundItemAdd () {
      if (this.isOldOrder()) {
        let item = await this.$post('/js-order-item/create', {
          orderId: this.order.id,
          isPay: false,
          isDeliver: false
        })
        this.order.items.push(item)
      } else
        this.order.items.push(util.clone(orderItemModel))
    },
    outboundItemDelete (id, index) {
      let _layerConfirmId = window.layer.confirm('删除后不可恢复，确认删除？', () => {
        util.loadBegin();
        this.$get('/js-order-item/del', {id}, () => {
          this.order.items.splice(index, 1)
          util.loadClose()
          window.layer.close(_layerConfirmId);
        }, () => {
          util.loadClose()
        })
      })
    },
    // 是创建新的订单 或者只是查看修改旧订单
    isOldOrder () {
      let id = parseInt(this.$route.params.id);
      this.page.index = parseInt(this.$route.params.rowIndex)
      return id || this.page.index
    },
    deletePrintImg (index) {
      this.printImgs.splice(index, 1)
    },
    async drawImg2Canvas1 (index) {
      if (this.show.printCanvas[index]) {
        this.$set(this.show.printCanvas, index, false)
        return
      }
      let self = this
      let oC = window.$laserOrderDialog.$refs.printCanvas[index]
      let ctx = oC.getContext('2d');
      // ⚠️ 不要用 new Image() + crossOrigin 直接加载 OSS 原图：
      //    页面上展示这些图用的都是 no-cors 的 <img>，而 OSS 不回 Vary: Origin，
      //    同一 URL 的缓存条目里没有 ACAO ⇒ cors 加载命中它必然失败（图片空白）。
      //    改为 fetch 取 blob 再用同源 blob URL 画布，与 LaserOrderDialog.drawImg2Canvas1 一致。
      const src = window.$laserOrderDialog.$refs.printImg[index].src
      let blob = calcPrintImgBlobCache.get(src)
      if (!blob) {
        const fetchResp = await fetch(src, {mode: 'cors', cache: 'no-store'})
        if (!fetchResp.ok) {
          self.$msg('图片转换失败', 'error')
          return
        }
        blob = await fetchResp.blob()
        calcPrintImgBlobCache.set(src, blob)
      }
      const blobUrl = URL.createObjectURL(blob)
      let oImg = new Image();
      oImg.onload = function () {
        URL.revokeObjectURL(blobUrl)
        // 图片真实宽高
        let realWidth = oImg.width
        let realHeight = oImg.height
        oC.width = realWidth
        oC.height = realHeight
        ctx.drawImage(oImg, 0, 0, realWidth, realHeight);
        // 反色处理
        let imgData = ctx.getImageData(0, 0, realWidth, realHeight);
        let newImg = ctx.createImageData(realWidth, realHeight);
        for (let i = 0; i < realWidth * realHeight; i++) {
          newImg.data[4 * i] = 255 - imgData.data[4 * i];
          newImg.data[4 * i + 1] = 255 - imgData.data[4 * i + 1];
          newImg.data[4 * i + 2] = 255 - imgData.data[4 * i + 2];
          newImg.data[4 * i + 3] = 255;
        }
        ctx.putImageData(newImg, 0, 0)
        self.$refs.printCanvas2Img[index].src = oC.toDataURL()
        self.$nextTick(() => {
          self.$set(self.show.printCanvas, index, true)
        })
      }
      oImg.onerror = function () {
        URL.revokeObjectURL(blobUrl)
        self.$msg('图片转换失败', 'error')
      }
      oImg.src = blobUrl
    },
    // ==================== 买料价格预测工具方法 ====================
    // 数字格式化：支持千分位与指定小数位，非法值返回占位符
    fmt (val, digits) {
      const numValue = val - 0
      if (val === null || val === undefined || val === '' || isNaN(numValue)) return '—'
      const fixedDigits = digits === undefined ? 0 : digits
      const parts = Math.abs(numValue).toFixed(fixedDigits).split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return (numValue < 0 ? '-' : '') + parts.join('.')
    },
    calculatePricePerKg() {
      const totalPrice = parseFloat(this.总价);
      const weight = this.结果 * 1000;

      if (!isNaN(totalPrice) && weight > 0) {
        this.每公斤价格 = (totalPrice / weight).toFixed(4);
      } else {
        this.每公斤价格 = 0;
      }
    },
    setOrderItemEdit (index) {
      console.log(index)
      this.$set(this.show.orderItemIsEdit, index, true);
      this.$nextTick(() => {
        this.$refs.orderItemDesc[index].focus()
      })
    }
  },
  watch: {
    'order.title': validFormTmp,
    'order.orderDesc': validFormTmp,
    'order.createUserId': validFormTmp,
    'order.customerUserId': _loadUserPic,
    user () {
      return this.$store.state.user;
    },
    $route (r) {
      if (r.params.onlyReplaceUrl)
        return
      this.loadOrder()
    },
    长 () {
      this.submit()
    },
    宽 () {
      this.submit()
    },
  },
  mounted () {
    window.$laserOrderDialog = this;
    window.$dropdownCreateUser = this.$refs.dropdownCreateUser;

    canvas = document.getElementById('drawingCanvas');
    ctx = canvas.getContext('2d');
    errorMessage = document.getElementById('errorMessage');
    infoMessage = document.getElementById('infoMessage');

    document.addEventListener('paste', handlePaste)
    document.addEventListener('keydown', handleKeyDown)

    // 计算器打开期间锁定页面滚动：隐藏计算器以外的滚动条，避免与计算器自身滚动条并排干扰
    this._prevBodyOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    // let self = this
    // this.$el.addEventListener('click', () => {
    //       self.submitEdit()
    //     }
    // )
    let cal = util.getStorage('js_cal')
    // eslint-disable-next-line no-prototype-builtins
    if (cal && cal.hasOwnProperty('长')) {
      this.长 = cal.长
      this.宽 = cal.宽
      this.厚 = cal.厚
      this.密度 = cal.密度
      this.单价 = cal.单价
      // 材质与密度必须一致：老数据没存材质时，按密度回推（0.791 = 不锈钢，其余按铁板）
      if (cal.材质) {
        this.selectedMaterial = cal.材质
        this.密度 = cal.材质 === '不锈钢' ? 0.791 : 0.785
      } else if (Math.abs(this.密度 - 0.791) < 0.001) {
        this.selectedMaterial = '不锈钢'
      } else {
        this.selectedMaterial = '铁板'
        this.密度 = 0.785
      }
      this.submit()
    }
    console.log(`      this.价格预设1 = this.结果 * 4500
      this.价格预设2 = this.结果 * 4200
      this.价格预设3 = this.结果 * 4000`)
  },
  created () {
    let self = this;

    function newOrder () {
      let laserOrder = util.clone(orderModel);
      laserOrder.items = []
      self.order = laserOrder
      self.order.createTime = new Date().Format('yyyy-MM-dd HH:mm:ss')
      // self.order.createUserId = self.user.id;
      // self.order.createUser = self.user
      self.order.customerUserId = 1
      self.order.customerUser = {
        name: '无名',
        id: 1
      }
      self.order.title = '-'
    }

    if (this.isOldOrder()) {
      this.loadOrder()
    } else {
      newOrder()
      this.$nextTick(() => {
        this.isShowThis = true
      })
    }
  },
  beforeDestroy () {
    // 恢复页面滚动
    document.body.style.overflow = this._prevBodyOverflow || ''
    document.removeEventListener('paste', handlePaste)
    document.removeEventListener('keydown', handleKeyDown)
    this.destroyEditor()
    console.log('laser order dialog destroy')
  },
}
</script>

<style scoped>
/* ==================== 买料价格预测 ==================== */
.main-body > div.buy-predict-wrap {
  display: block;
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.bp-head {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 2px solid #409eff;
  margin-bottom: 16px;
}

.bp-head h1 {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin: 0;
}

.bp-tag {
  font-size: 12px;
  color: #909399;
}

.bp-main {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.bp-inputs {
  flex: 1 1 320px;
  min-width: 300px;
}

.bp-outputs {
  flex: 1 1 420px;
  min-width: 340px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  align-content: start;
}

.bp-field {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.bp-field > label {
  width: 76px;
  flex: 0 0 76px;
  font-size: 13px;
  font-weight: bold;
  color: #333;
}

.bp-field .search-input {
  width: 140px;
}

.bp-val {
  font-size: 14px;
  font-weight: bold;
  color: #409eff;
}

.bp-val em {
  font-style: normal;
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

.bp-val .bp-coef {
  color: #e6a23c;
  font-weight: bold;
}

.bp-val .bp-nomodel {
  color: #f56c6c;
  font-weight: normal;
}

/* 通用预测（该厚度无成交 → 退回历史成交记录搬同材质样本最多档），用橙色与「精确预测」区分 */
.bp-val .bp-generic {
  color: #e6a23c;
  font-weight: bold;
}

.bp-generic-word {
  color: #e6a23c;
}

/* 未筛选条件的浏览模式（不填厚度 → 列出全部历史成交） */
.bp-all-word {
  color: #409eff;
}

.bp-out-tag.is-generic,
.bp-out.is-main .bp-out-tag.is-generic {
  color: #b88230;
  background: #fdf6ec;
  border-color: #f5dab1;
}

.bp-sync {
  margin-left: 8px;
  font-size: 11px;
  color: #c0c4cc;
  font-style: normal;
}

.bp-warnbox {
  align-items: flex-start;
  background: #fdf6ec;
  border-left: 3px solid #e6a23c;
  padding: 6px 10px;
  border-radius: 3px;
  font-size: 12px;
  color: #b88230;
  line-height: 1.5;
}

.bp-warnbox i {
  margin-right: 6px;
  margin-top: 2px;
}

.bp-out {
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 5px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
}

/* 主口径卡片（≤3mm 时为每平方价，否则为每吨价） */
.bp-out.is-main {
  background: #ecf5ff;
  border-color: #409eff;
}

.bp-out.is-main .bp-out-label {
  color: #409eff;
}

.bp-out-tag {
  margin-left: 5px;
  padding: 0 4px;
  font-size: 10px;
  line-height: 15px;
  color: #67c23a;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 3px;
  white-space: nowrap;
}

.bp-out.is-main .bp-out-tag {
  color: #fff;
  background: #409eff;
  border-color: #409eff;
}

.bp-out-label {
  font-size: 12px;
  color: #606266;
}

.bp-out-val {
  font-size: 22px;
  font-weight: bold;
  color: #409eff;
  line-height: 1.25;
}

.bp-out-val em {
  font-style: normal;
  font-size: 12px;
  font-weight: normal;
  color: #909399;
  margin-left: 4px;
}

.bp-na {
  grid-column: 1 / -1;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 5px;
  padding: 14px 16px;
  color: #f56c6c;
  font-size: 13px;
  line-height: 1.7;
}

.bp-na > i {
  font-size: 18px;
  margin-top: 2px;
}

.bp-na b {
  display: block;
  margin-bottom: 4px;
}

.bp-na p {
  margin: 2px 0;
  color: #909399;
  font-size: 12px;
}

.bp-formula {
  margin: 16px 0;
  padding: 10px 14px;
  background: #ecf5ff;
  border-left: 4px solid #409eff;
  border-radius: 0 4px 4px 0;
  font-size: 12px;
  line-height: 1.7;
}

.bp-formula-label {
  display: inline-block;
  font-weight: bold;
  color: #409eff;
  margin-right: 8px;
}

.bp-formula code {
  color: #303133;
  font-family: Consolas, Menlo, monospace;
}

.bp-src-title {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
  padding: 10px 0;
  border-bottom: 1px dashed #dcdfe6;
  margin-bottom: 14px;
}

.bp-src-title span {
  font-size: 12px;
  font-weight: normal;
  color: #909399;
  margin-left: 10px;
}

.bp-src-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

@media (max-width: 1100px) {
  .bp-src-grid {
    grid-template-columns: 1fr;
  }
}

/* 打印保险：成本预测数据不外泄给客户 */
@media print {
  .buy-predict-wrap {
    display: none !important;
  }
}

.bp-card {
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 5px;
  padding: 12px 14px;
  font-size: 12px;
}


.bp-card h5 {
  font-size: 13px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.bp-card h5 i {
  display: inline-block;
  font-style: normal;
  background: #409eff;
  color: #fff;
  border-radius: 3px;
  padding: 0 6px;
  margin-right: 6px;
  font-size: 11px;
}

.bp-kv {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
  line-height: 1.6;
}

.bp-kv > span {
  flex: 0 0 72px;
  color: #909399;
}

.bp-kv > b {
  color: #303133;
  font-weight: normal;
  word-break: break-all;
}

.bp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin-top: 8px;
}

.bp-table th {
  background: #eef2f7;
  color: #606266;
  font-weight: bold;
  text-align: left;
  padding: 5px 8px;
  border-bottom: 1px solid #dcdfe6;
  white-space: nowrap;
}

.bp-table td {
  padding: 5px 8px;
  border-bottom: 1px solid #f0f2f5;
  color: #606266;
}

.bp-table tr.bp-active td {
  background: #ecf5ff;
  color: #409eff;
  font-weight: bold;
}

.bp-table td.bp-hl {
  color: #409eff;
  font-weight: bold;
}

.bp-table td.up {
  color: #e6a23c;
}

.bp-table td.down {
  color: #909399;
}

.bp-table td.bp-empty {
  text-align: center;
  color: #c0c4cc;
  padding: 16px 0;
}

.bp-range {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 8px 10px;
  margin-bottom: 8px;
}

.bp-range-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  line-height: 1.8;
}

.bp-range-row > span {
  flex: 0 0 56px;
  color: #909399;
}

.bp-range-row > b {
  color: #303133;
}

.bp-range-row > b.up {
  color: #f56c6c;
}

.bp-range-row > b.down {
  color: #67c23a;
}

.bp-range-row > em {
  font-style: normal;
  font-size: 11px;
  color: #e6a23c;
}

/* 历史成交记录全部显示，不做内部滚动（跟随页面滚动） */
.bp-table-wrap {
  max-height: none;
  overflow: visible;
}

.bp-card-full {
  margin-bottom: 16px;
}

/* 「同厚度」小标签 */
.bp-same-tag {
  display: inline-block;
  margin-left: 5px;
  padding: 0 5px;
  font-style: normal;
  font-size: 10px;
  line-height: 15px;
  color: #409eff;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 3px;
  white-space: nowrap;
}

.bp-note {
  margin: 8px 0 0;
  font-size: 11px;
  color: #909399;
  line-height: 1.6;
}

/* 「最新」时间小标签 */
.bp-new-tag {
  display: inline-block;
  margin-left: 5px;
  padding: 0 5px;
  font-style: normal;
  font-size: 10px;
  line-height: 15px;
  color: #e6a23c;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 3px;
  white-space: nowrap;
}

.bp-time-cell {
  color: #e6a23c;
  white-space: nowrap;
}

.bp-time-text {
  color: #e6a23c;
}

.hl-thin {
  color: #409eff;
  font-size: 13px;
}

.bp-warn-text {
  color: #e6a23c;
}

/* ===== 可预测组合总览（快速查看） ===== */
.bp-cov {
  padding: 6px 14px 2px;
}

.bp-cov-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 7px 0;
  border-bottom: 1px dashed #f0f2f5;
}

.bp-cov-row:last-of-type {
  border-bottom: none;
}

.bp-cov-mat {
  flex: 0 0 54px;
  font-size: 12.5px;
  font-weight: bold;
  color: #909399;
  line-height: 26px;
}

.bp-cov-mat.is-on {
  color: #409eff;
}

.bp-cov-chips {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.bp-cov-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 1px;
  padding: 3px 8px;
  border: 1px solid #c6e2ff;
  border-radius: 4px;
  background: #f4f9ff;
  color: #409eff;
  cursor: pointer;
  font-family: inherit;
  font-size: 12.5px;
  line-height: 18px;
  transition: all .15s;
}

.bp-cov-chip b {
  font-size: 13px;
  font-weight: bold;
}

.bp-cov-chip em {
  font-style: normal;
  font-size: 11px;
  opacity: .85;
}

.bp-cov-chip i {
  margin-left: 3px;
  font-style: normal;
  font-size: 10.5px;
  color: #a8b6c4;
}

.bp-cov-chip:hover {
  border-color: #409eff;
  background: #ecf5ff;
  transform: translateY(-1px);
}

.bp-cov-chip.is-old {
  border-color: #f5dab1;
  background: #fffaf3;
  color: #c98b26;
}

.bp-cov-chip.is-old i {
  color: #d9b98c;
}

.bp-cov-chip.is-old:hover {
  border-color: #e6a23c;
  background: #fdf6ec;
}

.bp-cov-chip.is-stale {
  border-color: #fbc4c4;
  background: #fff6f6;
  color: #d45d5d;
}

.bp-cov-chip.is-stale i {
  color: #e3a3a3;
}

.bp-cov-chip.is-stale:hover {
  border-color: #f56c6c;
  background: #fef0f0;
}

.bp-cov-chip.is-on,
.bp-cov-chip.is-on:hover {
  border-color: #409eff;
  background: #409eff;
  color: #fff;
}

.bp-cov-chip.is-on i {
  color: #d6e8ff;
}

.bp-cov-none {
  flex: 1 1 auto;
  font-size: 12px;
  color: #c0c4cc;
  line-height: 26px;
}

.bp-cov-sum {
  flex: 0 0 auto;
  font-style: normal;
  font-size: 11.5px;
  color: #c8cdd4;
  line-height: 26px;
}

.bp-cov-hint {
  color: #409eff;
}

.bp-old-word {
  color: #e6a23c;
}

.bp-stale-word {
  color: #f56c6c;
}


.bp-files {
  margin-top: 10px;
  font-size: 11px;
  color: #909399;
}

.bp-files em {
  display: inline-block;
  font-style: normal;
  background: #f0f2f5;
  border-radius: 3px;
  padding: 1px 6px;
  margin: 2px 4px 2px 0;
  color: #606266;
}

.result-container {
  padding: 20px;
  margin-top: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.result-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.result-icon {
  margin-right: 10px;
  color: #007bff;
}

.result {
  font-family: 'Arial', sans-serif;
  color: #007bff;
  font-weight: bold;
}

.record-content {
  padding: 5px 0 0 5px;
  max-width: calc(100% - 34px);
}

#countImg {
  width: auto;
}

.pri .menu {
  width: 100%;
  top: 33px;
}

.fenpei .menu {
  width: 100%;
  max-height: 130px;
  overflow: auto;
  bottom: auto;
  top: 41px;
}

.ms-save-btns button > img {
  width: 28px;
  height: 20px;
}

.ms-save-btns button {
  margin-right: 5px;
}

.mx-datepicker {
  width: 130px;
}

.p0 {
  padding: 0;
}

h6 {
  white-space: nowrap;
  font-weight: bold;
  color: #333;
}

.b-f {
  background-color: #fff;
}

.main-body > div {
  display: flex;
  flex-direction: row;
}

.main-body {
  display: block;
  background-color: #f0f4f8;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.a-btn img {
  padding: 4px 6px;
}

.d-star p {
  margin-right: 5px;
}

.d-star {
  display: flex;
  align-items: center;
}

.d-star:last-child {
  margin-bottom: 10px;
}

#inp-hs {
  width: 90px;
  padding-right: 10px;
}

.v-leixing[disable] label,
div[disable] > div:hover {
  cursor: auto;
  background-color: unset;
}

.el-dropdown {
  width: 100%;
}

.is-create .el-dropdown {
  cursor: pointer;
}

.pics-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.file-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 320px;
  align-self: flex-start;
}

.pics-box-btns {
}

.pics-box > div {
  position: relative;
}

.pics-box .pic {
  max-width: 300px;
  max-height: 400px;
  margin: 0 10px 5px;
  box-shadow: 0 0 4px 1px #ccc;
  border-radius: 2px;
  min-width: 150px;
  object-fit: cover;
}

.file-name {
  margin-bottom: 10px;
}

.pics-box .left-right {
  position: absolute;
  bottom: 17px;
  left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffffc4;
  padding: 0 5px;
  border-radius: 3px;
  font-size: 10px;
  box-shadow: 0 0 3px 0 #ffffffbd;
  transition: background-color .2s, color .2s;
}

.pics-box .left-right:hover {
  background: #5160796e;
  color: #fff;
  box-shadow: 0 0 3px 0 #5160796e;
}

.pics-box .left-right.right {
  right: 12px;
  left: unset;
  flex-direction: row-reverse;
}

.pics-box .left-right.delete {
  right: 12px;
  left: unset;
  bottom: unset;
  top: 3px;
  flex-direction: row-reverse;
}

.pics-box .left-right.delete .img-right {
  width: 20px;
  padding: 3px 2px;
}

.pics-box .left-right .img-left,
.pics-box .left-right .img-right {
  width: 25px;
}

.pics-box .left-right .img-right {
  transform: rotateY(180deg);
}

.order-item input {
  width: 100px;
}

.price {
  display: flex;
  justify-content: flex-end;
  padding: 5px 15px 5px 0;
}

.create-time {
  padding: 3px 5px;
}

.price span {
  font-size: large;
  font-weight: bold;
}

.el-divider--horizontal {
  margin: 12px 0;
}

.switch {
}

.switch .left,
.switch .right {
  position: absolute;
  z-index: 520;
  width: 50px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 3px;
  padding: 5px 0;
  transition: background-color .2s;
  background: #00000063;
}

.switch .left:hover,
.switch .right:hover {
  background: #00000063;
}

.switch .left {
  left: 50px;
  transform: translateY(-50%) rotateZ(180deg);
}

.switch .right {
  right: 50px;
}

.switch-page {
  position: absolute;
  z-index: 520;
  top: calc(50% + 30px);
  color: #fff;
  text-align: center;
  width: 55px;
}

.switch-page-left {
  left: 50px;
}

.switch-page-right {
  right: 50px;
}

.d-content header {
  justify-content: space-between;
}

@media only screen and (max-width: 749px) {
  .d-content header {
    padding: 0;
    height: 66px;
  }

  .main-body > div {
    flex-direction: column;
  }

  .switch .left,
  .switch .right {
    background: #00000063;
  }

  .switch .left {
    left: 0;
  }

  .switch .right {
    right: 0;
  }

  .switch .left:hover,
  .switch .right:hover {
    background: #00000063;
  }
}

.d-content-print {
  overflow: auto;
}

.print-content {
  padding-top: 138%;
  margin-bottom: 50px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: visible;
}

.print-content-page {
  position: absolute;
  width: 100%;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  height: 100%;
}

.print-content-title {
  text-align: center;
  padding-bottom: 40px;
  font-size: 25px;
  font-weight: bold;
}

.print-content-input {
  margin-left: 10px;
  min-width: 100px;
  border-bottom: 1px solid;
}

.print-img-box {
  width: 100%;
  height: 100%;
  border-radius: 3px;
  transform: scale(0.95);
  position: relative;
  transition: box-shadow .2s;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.print-img-box:hover {
  box-shadow: 0px 0px 5px 3px #cccccc57;
}

.print-img-canvas {
  position: absolute;
}

.print-btns {
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  align-items: center;
  align-content: center;
  background: white;
  border-radius: 3px;
}

.print-imgs-2 .print-img-box {
  height: 50%;
}

.print-imgs-3 .print-img-box:nth-child(1) {
  height: 50%;
}

.print-imgs-3 .print-img-box:nth-child(2),
.print-imgs-3 .print-img-box:nth-child(3) {
  width: 50%;
  height: 50%;
}

.print-imgs-4 .print-img-box {
  width: 50%;
  height: 50%;
}

.print-img-box img {
  object-fit: contain;
  object-position: center center;
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  border-radius: 3px;
}

.header-print {
  z-index: 100;
  width: auto;
  position: absolute;
  right: 0;
}

.outbound {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.outbound h6 {
  margin-bottom: 15px;
  font-weight: bold;
}

.outbound .v-leixing {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  transition: box-shadow 0.3s ease;
}

.outbound .v-leixing:hover {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.outbound .el-select {
  width: 100%;
  margin-bottom: 10px;
}

.outbound .price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.outbound .price span {
  font-size: 16px;
  font-weight: bold;
}

.outbound .price input {
  width: 100px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.outbound .order-item-del {
  color: #ff4d4f;
  cursor: pointer;
  transition: color 0.3s ease;
}

.outbound .order-item-del:hover {
  color: #ff1919;
}

.outbound .user {
  padding-right: 10px;
}

.order-item-del {
  position: absolute;
  right: 0;
  transform: translateY(-50%);
  top: 50%;
}

.outbound .v-leixing {
  transition: box-shadow 0.3s ease;
  position: relative;
}

.outbound .v-leixing:hover {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.outbound-backup {
  width: auto;
}

.outbound .price span {
  font-size: inherit;
  padding-left: 10px;
}

.container {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.input-field {
  flex: 1;
  min-width: 120px;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #45a049;
}

.canvas-container {
  margin-top: 20px;
  text-align: center;
}

canvas {
  border: 1px solid #ddd;
  background-color: white;
  max-width: 100%;
}

.error-message {
  color: #f44336;
  text-align: center;
  margin-top: 10px;
  font-weight: bold;
}

.info-message {
  color: #2196F3;
  text-align: center;
  margin-top: 10px;
  font-weight: bold;
}

.main .r {
  max-width: calc(40.3333% - 40px);
  min-width: calc(40.33333% - 40px);
}

.main .l {
  max-width: calc(58.6666% - 40px);
  min-width: calc(58.33333% - 40px);
}
/* ==================== 计算器布局调整（置于样式末尾，覆盖上方原生 .l/.r 宽度） ==================== */
/* 1) 长 / 宽 / 厚 / 密度 / 材质 / 结果 横向并列（.l 为 flex 容器） */
.main .l {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 14px 18px;
  max-width: 100%;
  min-width: 100%;
  box-sizing: border-box; /* .l/.r 自带左右 20px padding，content-box 会撑出横向滚动条 */
}

.main .l > div {
  flex: 0 0 auto;
}

/* 输入框上方的 h6 标签固定行高，便于与无标签的材质按钮行对齐 */
.main .l > div > h6 {
  margin: 0 0 4px;
  line-height: 22px;
  white-space: nowrap;
}

/* 2) 尺寸输入缩短 */
.main .l .search-input {
  width: 108px;
}

/* 3) 材质按钮横向并列、不换行（补上 h6 标签的高度以对齐输入框） */
.main .l > div.mat-group {
  padding-top: 26px;
}

.main .l .el-radio-group {
  display: flex;
  flex-wrap: nowrap;
}

.main .l .el-radio-group .el-radio-button__inner {
  padding: 7px 10px;
}

/* 4) 结果块占满剩余宽度 */
.main .l > div:last-child {
  display: block;
  flex: 1 1 320px;
  min-width: 280px;
}

.main .l > div:last-child > .result-container {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin-top: 0;
  padding: 12px 14px;
}

.main .l > div:last-child .result-item {
  margin-bottom: 6px;
}

/* 5) 预览另起一行并横向占满 */
.main-body > div {
  flex-wrap: wrap;
}

.main .r {
  max-width: 100%;
  min-width: 100%;
  margin-top: 20px;
  box-sizing: border-box;
}

.main .r .container,
.main .r .canvas-container {
  width: 100%;
  box-sizing: border-box; /* .container 自带 20px padding，不收敛会撑出横向滚动条 */
  margin-top: 0;
}

</style>
<style>
.el-timeline-item__content {
  display: flex;
  align-items: center;
}

@media print {
  body > *:not(#printContent) {
    display: none;
  }

  /* 打印时解除计算器对 body 的滚动锁定，避免多页内容被裁剪 */
  body {
    overflow: auto !important;
  }
}

@media screen {
  #printContent {
    display: none;
  }
}

</style>
